module.exports = __webpack_public_path__ + "28e2c813.png";